import '../css/company.css'
import React, {useState} from "react";
import {
    FileUploadButton, IntlMessageValue,
    UniButton,
    UniCards,
    UniCol,
    UniForm,
    UniRow,
    UniSpinner
} from "../../../../@WUM/core/Elements";
import {ResponseUSerProfil} from "../API/response/support_software";
import {_UserInterface} from "../API/request/SupportSoftwareApi.interface";
import {config, output} from "./configuration/mapping";
import {support_software} from "../API/request/support_software";
import { notify_save } from '../../../../@WUM/core/component/const/notification.service';
import { error, IntlMessage } from '../../../../@WUM/core/Elements/index'
import init from '../../../../@WUM/core/form-serilizer/seriliaze/Formserialize'
import {useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import { Form } from 'react-bootstrap'
import Stats from "../../../../@WUM/core/Elements/Stats";
import Country from "../../../../@WUM/core/Elements/Country";

const CompanyOverviewNew = (props:{value:any}) =>{
    const {page} = useParams<{ page: string }>();

    const Store = useSelector((state: any) => state)
    const history = useNavigate()
    // @ts-ignore
    // let Profil:_UserInterface[] = [Profils !== undefined ? Profils: undefined]
    /**
     * Neuladen der Seite
     */
    const routeChange = (path: string) => {
        let paths = path
        history(paths)
    }
    const [currentTutorial, setCurrentTutorial] = useState<_UserInterface[]>(
         []
    )
    const Send = (event:any) => {
        event.preventDefault()
        event.stopPropagation()

        /*
               *  Wichtig zum Rausholen der Datan aus Formular und senden
               *  Das Interface muss immer angepasst werden
               */
        let Data = init()

        let reauestData: _UserInterface[] & config = Object.assign(
            {},
            currentTutorial,
            output(Data)
        )

        /*
         *  Senden der Erhaltenen Daten an das Frontend
         */
        support_software
            .updatePost(reauestData, 0)
            .then((response) => {
                setCurrentTutorial({ ...currentTutorial })
                notify_save(Store)
                routeChange(`/company/overview/${page}` )
            })
            .catch((e:any) => {
                error(e)
            })
    }




        return (
            <>
                <Form
                    id={'form001'}
                    noValidate
                    onSubmit={(e) =>
                        Send(e)
                    }
                >
                    <div className={'ticketsystem'} style={{padding: '25px'}}>
                        <UniCards class={'p-3'}>
                            <h3><IntlMessage Store={Store} messageId="company.header" /></h3>
                            <p>
                                <IntlMessage Store={Store} messageId="company.description" />
                            </p>
                            <UniRow>
                                <UniCol class={'col-3 p-3'}>
                                    <FileUploadButton
                                        classNameInput={'d-none'}
                                        img={{width: '300px', height: '50px'}}
                                        classNameButton={'mt-3'} placeholderImg={'/assets/img.png'}
                                        styleButton={{width: '100%'}}
                                        ButtonLabel={IntlMessageValue('de', 'logo.button.label', Store)}
                                        DelButtonLabel={IntlMessageValue('de', 'logo.delbutton.label', Store)}
                                        name={'logo'}
                                        accept={"image/png, image/jpeg, image/webp"}/>
                                    <div className={'mt-5'}>
                                    <FileUploadButton
                                        classNameInput={'d-none'} placeholderImg={'/assets/img.png'}
                                        img={{width: '200px', height: '200px'}}
                                        classNameButton={'mt-3'}
                                        styleButton={{width: '100%'}}
                                        ButtonLabel={IntlMessageValue('de', 'favicon.button.label', Store)}
                                        DelButtonLabel={IntlMessageValue('de', 'favicon.delbutton.label', Store)}
                                        name={'favicon'}
                                        accept={"image/png, image/jpeg, image/webp"}/>
                                    </div>
                                    <Stats
                                        preText={IntlMessageValue('de', 'valid.company.preText', Store)}
                                        afterText={IntlMessageValue('de', 'valid.company.afterText', Store)}
                                        validText={IntlMessageValue('de', 'valid.company.validText', Store)}
                                        replaceName={'[PercentHolder]'} validAfterName={IntlMessageValue('de', 'valid.company.validAfterName', Store)} validIcon={'verified_user'} ValidIconvariant={'-outlined'}
                                        item={[
                                        {title:'Logo',percent:13,check: false },
                                        {title:'Favicon',percent:10,check: false },
                                        {title:IntlMessageValue('de', 'common.companyname', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.employer', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.street', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.zip', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.city', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.country', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.phone', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.email', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.url', Store),percent:5,check: false},
                                        {title:IntlMessageValue('de', 'common.vat', Store),percent:4,check: false},
                                        {title:IntlMessageValue('de', 'common.tax', Store),percent:4,check: false},
                                        {title:IntlMessageValue('de', 'common.accountHolder', Store),percent:4,check: false},
                                        {title:IntlMessageValue('de', 'common.accountNumber', Store),percent:4,check: false},
                                        {title:IntlMessageValue('de', 'common.blz', Store),percent:4,check: false},
                                        {title:IntlMessageValue('de', 'common.bank', Store),percent:4,check: false},
                                        {title:IntlMessageValue('de', 'common.iban', Store),percent:4,check: false},
                                        {title:IntlMessageValue('de', 'common.bic', Store),percent:4,check: false}
                                    ]} />
                                </UniCol>
                                <UniCol>

                                    <UniRow>
                                        <UniCol class={'border-right  p-3'}>
                                            <UniForm.FormControl name={'id'}  required={true} defaultValue={"0"}
                                                                 type={'hidden'}/>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.companyname', Store)}/>
                                                <UniForm.FormControl name={'name'}  required={true}
                                                                     type={'name'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.employer', Store)}/>
                                                <UniForm.FormControl name={'owner'}  required={true}
                                                                     type={'text'}/>
                                            </UniForm.InputGroup>
                                            <br/>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.street', Store)}/>
                                                <UniForm.FormControl name={'street'}  required={true}
                                                                     type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.zip', Store)}/>
                                                <UniForm.FormControl name={'zip'}  required={true}
                                                                     type={'text'}/>
                                            </UniForm.InputGroup>

                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.city', Store)}/>
                                                <UniForm.FormControl name={'cityL'}  required={true}
                                                                     type={'text'}/>
                                            </UniForm.InputGroup>
                                                <UniForm.InputGroup>
                                                    <UniForm.InputGroupText  text={IntlMessageValue('de', 'common.country', Store)}/>
                                                    <Country   mode={'country'} name={'country'} className={'mb-3'} defaultValue={""}/>
                                                </UniForm.InputGroup>
                                            <br/>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.phone', Store)}/>
                                                <UniForm.FormControl name={'phone'}  required={true}
                                                                     type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.email', Store)}/>
                                                <UniForm.FormControl name={'mail'}  required={true}
                                                                     type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.url', Store)}/>
                                                <UniForm.FormControl name={'website'}  required={true}
                                                                     type={'text'}/>
                                            </UniForm.InputGroup>
                                        </UniCol>
                                        <UniCol class={'p-3'}>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.vat', Store)}/>
                                                <UniForm.FormControl name={'vat'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.tax', Store)}/>
                                                <UniForm.FormControl name={'tax'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                            <br/>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.accountHolder', Store)}/>
                                                <UniForm.FormControl name={'accountHolder'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.accountNumber', Store)}/>
                                                <UniForm.FormControl name={'accountNumber'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.blz', Store)}/>
                                                <UniForm.FormControl name={'blz'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.bank', Store)}/>
                                                <UniForm.FormControl name={'bank'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.iban', Store)}/>
                                                <UniForm.FormControl name={'iban'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                            <UniForm.InputGroup>
                                                <UniForm.InputGroupText text={IntlMessageValue('de', 'common.bic', Store)}/>
                                                <UniForm.FormControl name={'bic'}  type={'text'}/>
                                            </UniForm.InputGroup>
                                        </UniCol>
                                    </UniRow>
                                </UniCol>
                            </UniRow>
                            <br/><br/>

                            <UniButton type={'submit'} variant={'success'}>{IntlMessageValue('de', 'common.save', Store)}</UniButton>
                        </UniCards>
                    </div>
                </Form>
            </>
        )
    }


export default CompanyOverviewNew;
